module.exports = __webpack_public_path__ + "img/4051.f8f15a7f.jpg";